<template>
  <v-dialog hide-overlay v-model="dialog" fullscreen @keydown.esc="onDialogClose">
    <v-dialog v-model="dialogSavedInvoice" persistent max-width="430">
      <v-card tile flat color="white">
        <v-card-text class="pa-0">
          <v-row justify="center">
            <v-alert tile dense type="success" class="body-1" min-width="430">
              Invoice&nbsp;
              <strong>{{ invoice != null ? invoice.invoice_id : null }}</strong
              >&nbsp; was successfully updated.
            </v-alert>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              class="font-weight-bold ml-4"
              depressed
              tile
              @click="onDialogClose"
              >OK</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-card flat color="white">
      <v-row no-gutters>
        <v-col>
          <v-row justify="center">
            <v-subheader class="title primary--text"
              >Edit Invoice {{ invoice != null ? invoice.invoice_id : null }}</v-subheader
            >
          </v-row>

          <v-row justify="center">
            <span class="primary--text subtitle-1">{{ getInvoiceTitle() }}</span>
          </v-row>
        </v-col>

        <v-col cols="1" class="d-flex justify-end">
          <v-btn
            text
            color="black"
            class="font-weight-bold caption"
            @click="onDialogClose"
          >
            <v-icon size="20">mdi-close</v-icon>CLOSE
          </v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters class="pl-2 pt-2" v-if="invoice != null">
        <v-col>
          <span class="font-weight-bold body-2 primary--text">
            To:
            <v-chip
              label
              small
              outlined
              color="primary"
              class="caption font-weight-bold text-uppercase px-1"
              >{{ invoice.company.name }}</v-chip
            >
          </span>
        </v-col>

        <v-col class="d-flex justify-center">
          <span class="font-weight-bold body-2 primary--text">
            Currency:
            <v-chip
              label
              small
              outlined
              color="primary"
              class="caption font-weight-bold px-1"
              >{{ invoice.currency }}</v-chip
            >
          </span>
        </v-col>

        <v-col class="d-flex justify-end">
          <span class="font-weight-bold body-2 primary--text">
            By:
            <v-chip
              label
              small
              outlined
              color="primary"
              class="caption font-weight-bold mx-2"
              >{{ invoice.user }}</v-chip
            >
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-divider></v-divider>
      </v-row>

      <v-row v-if="invoice != null" justify="center" class="pb-1">
        <span class="subtitle-1 font-weight-bold primary--text">{{
          getInvoiceType()
        }}</span>
      </v-row>

      <v-row no-gutters class="px-2 mb-4" v-if="invoice != null">
        <v-col style="background-color: #2196f3" class="pa-2">
          <v-card flat color="white" class="pb-4">
            <v-card-text class="pa-1">
              <v-row>
                <v-col cols="7">
                  <v-row no-gutters>
                    <v-col>
                      <span class="black--text pr-3 pt-1">Invoice Date:</span>
                      <flat-pickr
                        v-model="invoice.issued_date"
                        class="form-control"
                        style="max-width: 130px; background: white"
                        placeholder="Select Invoice Date"
                        :config="config"
                        name="date"
                      ></flat-pickr>
                      <!-- <span v-else class="pt-1">{{invoice.issued_date}}</span> -->
                    </v-col>

                    <v-col>
                      <span class="black--text pr-3 pt-1">Due Date:</span>
                      <flat-pickr
                        v-model="invoice.due_date"
                        class="form-control"
                        style="max-width: 130px; background: white"
                        placeholder="Select Due Date"
                        :config="config"
                        name="date"
                      ></flat-pickr>
                      <!-- <span v-else class="pt-1">{{invoice.due_date}}</span> -->
                    </v-col>

                    <v-col cols="5">
                      <span class="black--text py-1">Reference:</span>
                      <input class="form-control" v-model="invoice.reference" />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="d-flex justify-end">
                  <span class="font-weight-bold body-2 primary--text">
                    <v-chip
                      label
                      small
                      outlined
                      :color="getInvoiceStatus().color"
                      class="caption font-weight-bold mx-2"
                      >{{ getInvoiceStatus().title }}</v-chip
                    >
                  </span>
                </v-col>
              </v-row>

              <v-divider></v-divider>

              <v-row justify="start" class="pb-3">
                <v-btn
                  small
                  tile
                  outlined
                  color="primary"
                  class="font-weight-bold text-sm-caption px-1 mx-4"
                  @click="addNewComponent"
                  >ADD ITEM</v-btn
                >

                <v-btn
                  small
                  tile
                  outlined
                  color="error"
                  class="font-weight-bold text-sm-caption px-1"
                  @click="addDiscountComponent"
                  >ADD DISCOUNT</v-btn
                >
              </v-row>

              <v-row no-gutters>
                <v-col v-if="invoice != null">
                  <quotation-invoice-table
                    v-model="invoice.af_line_items"
                    :quotation="invoice.quotation"
                    :editable="true"
                    :view="'EDIT'"
                    v-on:updated="on_financials_updated"
                  ></quotation-invoice-table>
                </v-col>
              </v-row>

              <v-row justify="start" class="pt-3">
                <v-btn
                  small
                  tile
                  outlined
                  color="primary"
                  class="font-weight-bold text-sm-caption px-1 mx-4"
                  @click="addNewComponent"
                  >ADD ITEM</v-btn
                >

                <v-btn
                  small
                  tile
                  outlined
                  color="error"
                  class="font-weight-bold text-sm-caption px-1"
                  @click="addDiscountComponent"
                  >ADD DISCOUNT</v-btn
                >
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-row justify="end">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      tile
                      small
                      color="secondary"
                      class="font-weight-bold mr-3"
                      @click="onSaveInvoice(invoice.status)"
                      >SAVE</v-btn
                    >
                  </template>
                  Save invoice without changing the status
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      tile
                      small
                      color="primary"
                      class="font-weight-bold mx-3"
                      :disabled="invoice.authorised"
                      @click="onSaveInvoice(CONSTANT.STATUS.INVOICE.SUBMITTED)"
                      >SAVE AS SUBMITTED</v-btn
                    >
                  </template>
                  Save invoice as a submitted
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      tile
                      small
                      color="success"
                      class="font-weight-bold ml-3"
                      @click="onSaveInvoice(CONSTANT.STATUS.INVOICE.AUTHORISED)"
                      >SAVE AS APPROVED</v-btn
                    >
                  </template>
                  Save invoice as authorised / approved
                </v-tooltip>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";
import QuotationInvoiceTable from "@/components/shared/QuotationInvoiceTable.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";
export default {
  props: ["value", "dialog"],
  components: {
    QuotationInvoiceTable,
    flatPickr,
  },

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      dialogSavedInvoice: false,

      invoice: this.value,
      invoiceOverview: null,

      updatedInvoice: null,
      invoiceUpdated: false,

      financials_updated: false,
    };
  },

  created() {},

  mounted() {},

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.invoice = this.value;
        // console.log(this.invoice)

        this.dialogSavedInvoice = false;

        this.updatedInvoice = null;

        this.financials_updated = false;

        this.invoiceUpdated = false;

        this.invoiceOverview = JSON.parse(JSON.stringify(this.invoice));
      } else {
        this.invoice = null;
        this.invoiceOverview = null;
      }
    },
  },

  methods: {
    /**
     * Get invoice title
     */
    getInvoiceTitle() {
      if (this.invoice == null) {
        return null;
      }

      var quotationIDLabel =
        this.invoice.quotation.quotation_id != null
          ? this.invoice.quotation.quotation_id
          : "DRAFT";

      return `[${quotationIDLabel}] ${this.invoice.quotation.transaction_type} ${this.invoice.quotation.container_load} ${this.invoice.quotation.incoterm.incoterm} ${this.invoice.quotation.cargo_type.code} ${this.invoice.quotation.origin_port.name} to ${this.invoice.quotation.destination_port.name}`;
    },

    /** Get Invoice Type */
    getInvoiceType() {
      let title = null;

      switch (this.invoice.invoice_type) {
        case constant.SHIPMENT_INVOICE:
          title = "Shipment Invoice";
          break;

        case constant.TAXES_DUTIES_INVOICE:
          title = "Taxes & Duties Invoice";
          break;

        case constant.OTHER_SERVICES_INVOICE:
          title = "Other Services Invoice";
          break;

        default:
          break;
      }

      return title;
    },

    /**
     * Invoice status
     */
    getInvoiceStatus: function () {
      var color = "black";
      var msg = "Draft Invoice, waiting to be submitted";
      var title = "DRAFT";

      switch (this.invoice.status) {
        case constant.STATUS.INVOICE.DRAFT:
          break;
        case constant.STATUS.INVOICE.SUBMITTED:
          color = "grey darken-3";
          title = "SUBMITTED";
          msg = "This invoice has been submitted. Awaiting approval.";
          break;
        case constant.STATUS.INVOICE.AUTHORISED:
          color = "amber darken-4";
          title = "APPROVED";
          msg = "This invoice has been authorised. Awaiting payment.";
          break;
        case constant.STATUS.INVOICE.PAID:
          color = "green darken-2";
          title = "PAID";
          msg = "This is a paid invoice.";
          break;
        case constant.STATUS.INVOICE.DELETED:
          color = "error";
          title = "DELETED";
          msg = "This is a deleted invoice.";
          break;
        case constant.STATUS.INVOICE.VOIDED:
          color = "error darken-2";
          title = "VOIDED";
          msg = "This is a voided invoice.";
          break;
        default:
          break;
      }

      return { color: color, title: title, msg: msg };
    },

    /**
     * Add general item component to FC
     */
    addNewComponent() {
      this.invoice.af_line_items.push({
        type: constant.TYPE_GENERAL_ITEM,
        code: "OT-GEN",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.invoice.currency,
        description: "General item",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      });
    },

    /**
     * Add discount/rebate component to FC
     */
    addDiscountComponent() {
      this.invoice.af_line_items.push({
        type: constant.TYPE_DISCOUNT_REBATE,
        code: "OT-REB",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.invoice.currency,
        description: "Discount/rebate description",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      });
    },

    /**
     * on financials updated
     */
    on_financials_updated() {
      this.financials_updated = true;
    },

    /**
     * On update Invoice
     */
    onSaveInvoice(status) {
      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "Saving invoice...";

      // validate date
      if (this.invoice.issued_date == null || this.invoice.due_date == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "Invalid Issued Date or Due Date";
        this.$root.blockUIshow = false;
        return;
      }

      // update the invoice status
      this.invoice.status = status;

      this.$https
        .put(
          `/api/quotations/${this.invoice.quotation_id}/invoices/${this.invoice.invoice_id}`,
          this.invoice
        )
        .then((resp) => {
          var response = resp.data;
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.updatedInvoice = response.data;
            this.invoiceUpdated = true;
            this.dialogSavedInvoice = true;
          } else {
            console.log(response);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarTimeout = 10000;
            this.snackbarMsg = response.msg;
          }
          this.$root.blockUIshow = false;
        })
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
          this.$root.blockUIshow = false;
        });
    },

    /**
     * on dialog close
     */
    onDialogClose() {
      this.$emit(
        "dialog-close",
        constant.DIALOG_MANAGE_INVOICE,
        this.updatedInvoice,
        this.invoiceUpdated
      );
    },
  },

  computed: {
    invoice_line_items: {
      get() {
        if (this.invoice == null) {
          return [];
        }
        // return the af line items
        return this.invoice.af_line_items;
      },
    },

    is_valid: {
      get() {
        return this.invoice_line_items != null && this.invoice_line_items.length > 0;
      },
    },
  },
};
</script>

<style scoped></style>
